import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import FeaturedBanner from './featured-banner';
import FeaturedCollectionRows from './featured-collection-rows';
import Tiles from '../../elements/tiles';
import '../../package-styles/slick.css';

const FeaturedContainer = styled.div``;

const Featured = () => {
    const data = useStaticQuery(graphql`
        query {
            featured: allWpPage(filter: { title: { eq: "Featured" } }) {
                edges {
                    node {
                        featured_page_acf {
                            featuredBanner {
                                bannerBackgroundColor
                                bannerCaption
                                bannerHeadline
                            }
                            featuredContentRows {
                                collectionImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1200) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                collectionDescription
                                collectionHandle
                                collectionTitle
                            }
                            featuredTiles {
                                sectionTitle
                                tiles {
                                    tileLink {
                                        title
                                        url
                                    }
                                    tileImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 600) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                    tileHoverColor
                                    tileShortDescription
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const page = data && data.featured.edges[0].node;
    const { featuredBanner, featuredContentRows, featuredTiles } =
        page.featured_page_acf || {};
    return (
        <FeaturedContainer>
            <FeaturedBanner content={featuredBanner} />
            <FeaturedCollectionRows rows={featuredContentRows} />
            <Tiles content={featuredTiles} />
        </FeaturedContainer>
    );
};

export default Featured;
